@if (isUserLogin) {
  @if ((menuType() === 'over' && !menuService.showMenu()) || menuType() !== 'over') {
    <app-header></app-header>
  }

  <mat-drawer-container autosize="true" class="side-nav" [class.full-height]="menuType() == 'over' && menuService.showMenu()">
    <mat-drawer #sidenav [mode]="menuType()" class="side-menu" [opened]="menuService.showMenu()" position="start">
      <app-nav class="h-full" />
    </mat-drawer>
    <mat-drawer-content>
      <section class="outlet">
        <!-- <div>
                <app-bread-crumb></app-bread-crumb>
            </div> -->
        <router-outlet></router-outlet>
      </section>
    </mat-drawer-content>
  </mat-drawer-container>
} @else {
  <app-loading />
}
